
export const LogEventName = {
    activateAccount: 'activate_account',
    updateProfile: 'update_profile',
    switchUser: 'switch_user',
    findDoctor: 'find_doctor',
    findDoctorBySameDayVisit: 'find_doctor_by_sameDay_visit',
    findDoctorByVirtualVisit: 'find_doctor_by_virtual_visit',
    findDoctorByInPersonVisit: 'find_doctor_by_inPerson_visit',
    findDoctorBySpecialty: 'find_doctor_by_specialty',
    findDoctorByScanning: 'find_doctor_by_scanning',
    findDoctorByFavorites: 'find_doctor_by_favorites',
    findDoctorByAppointment: 'find_doctor_by_appointment',
    findDoctorByRecentSearches: 'find_doctor_by_recent_searches',
    findDoctorByPopularSearches: 'find_doctor_by_popular_searches',
    sendFeedback: 'send_feedback',
    resetLanguage: 'reset_language',
    loginWithPwd: 'login_with_pwd',
    loginWithApple: 'login_with_apple',
    loginWithGoogle: 'login_with_google',
    loginWithFacebook: 'login_with_facebook',
    loginWithPatientPortal: 'login_with_patient_portal',
    resetPwd: 'reset_pwd',    // 忘记重置
    updatePwd: 'update_pwd',  // 登录更新
    inviteFriends: 'invite_friends',
    getRoute: 'get_route',
    preBookAppointment: 'pre_book_appointment',  // 准备预约
    bookAppointment: 'book_appointment',
    cancelAppointment: 'cancel_appointment',
    renewalMedication: 'renewal_medication',
    signUpWithEmail: 'signUp_with_email',
    signUpWithRegistrationCode: 'signUp_with_registrationCode',
    signUpFromPatientPortal: 'signUp_from_patientPortal',
    deleteAccount: 'delete_account',
    deleteFile: 'delete_file',
    renameFile: 'rename_file',
    addFile: 'add_file',
    favoriteDoctor: 'favorite_doctor',
    cancelFavoriteDoctor: 'cancel_favorite_doctor',
    favoritePharmacy: 'favorite_pharmacy',
    cancelFavoritePharmacy: 'cancel_favorite_pharmacy',
    addInsuranceCard: 'add_insurance_card',
    verifyAccessCode: 'verify_access_code',
    loginRtmServer: 'login_rtm_server',
    joinRtcChannel: 'join_rtc_channel',
    sendChatInvites: 'send_chat_invites',
    joinChatRoom: 'join_chatRoom',
    leaveChatRoom: 'leave_chatRoom',
    beginVideo: 'begin_video',
    endVideo: 'end_video',
    sendTelehealthMsg: 'send_telehealth_msg',
    sendInboxMsg: 'send_inbox_msg',
    replyInboxMsg: 'reply_inbox_msg',
    openWithBrowser: 'open_with_browser',
    share: 'share',
    submitVitalSign: 'submit_vital_sign',
    updateReminder: 'update_reminder',
    openWithScheme: 'open_with_scheme',
    getMeetingInfo: 'get_meeting_info'
}
